<!-- Fixed Header -->
<nav
  class="fixed top-0 left-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm"
>
  <div class="max-w-2xl mx-auto px-2 sm:px-0">
    <div class="flex items-center justify-between h-14">
      <!-- Left: Back -->
      <div class="flex items-center flex-1 mr-4">
        <button
          (click)="goBack()"
          class="back-btn"
          title="Back to assignments"
        >
          <lucide-icon
            [img]="icons.ArrowLeft"
            class="w-3.5 h-3.5"
          ></lucide-icon>
          <span class="hidden sm:inline">Assignments</span>
        </button>
      </div>

      <!-- Center: Tabs -->
      <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-1 shrink-0">
        <a routerLink="students" routerLinkActive="tab-active" class="tab">
          <lucide-icon
            [img]="icons.GraduationCap"
            class="w-3.5 h-3.5"
          ></lucide-icon>
          Students
        </a>
        <a routerLink="view" routerLinkActive="tab-active" class="tab">
          <lucide-icon
            [img]="icons.FileText"
            class="w-3.5 h-3.5"
          ></lucide-icon>
          Questions
        </a>
      </div>

      <!-- Right: Share Button -->
      <div class="flex items-center justify-end flex-1 ml-4">
        @if (assignment$ | async; as assignment) {
          @if (assignment.shareCode) {
            <button
              (click)="copyShareLink(assignment)"
              class="share-btn"
              [class.share-btn-copied]="copied()"
              [title]="copied() ? 'Copied!' : 'Copy student link'"
            >
              <lucide-icon
                [img]="copied() ? icons.Check : icons.Share2"
                class="w-3.5 h-3.5"
              ></lucide-icon>
              <span class="hidden sm:inline">
                {{ copied() ? "Copied!" : "Student Link" }}
              </span>
            </button>
          }
        }
      </div>
    </div>
  </div>
</nav>

<!-- Content area -->
<div class="pt-14">
  <router-outlet></router-outlet>
</div>
